module.exports = __webpack_public_path__ + "media/start-countdown.599b7d1c.mp3";